<template>
  <ul class="plain-unordered-list">
    <li v-for="(doc, index) in documents" :key="index">
      <a :href="getUrl(doc)" target="_blank">
        {{doc.name}}
      </a>
    </li>
  </ul>
</template>

<script>
import DocumentsService from '@/services/DocumentsService';

export default {
  name: 'DocumentList',
  props: {
    documents: {
      type: Array,
    },

  },
  methods:{
    getUrl(document){
      return DocumentsService.getDocumentUrl(document.id);
    },
  },
};
</script>
